import CityAPI from 'api/city';

export const CITY_LOAD_DATA = 'CITY_LOAD_DATA';

export const cityLoadData = slug => {
    return {
        type: CITY_LOAD_DATA,
        payload: CityAPI.get(slug),
    };
};
